import type { IconSvgObject } from './types';

const CableCarIcon: IconSvgObject = [
  ["path", { d: "M4 2H14M14 2H20M14 2L12 5.5M9 5.5H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 16H20M12 8V16", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M4 15.5C4 13.3081 4.45039 11.2664 4.85758 9.86842C5.19318 8.71621 6.27809 8 7.47818 8H16.5218C17.7219 8 18.8068 8.7162 19.1424 9.86839C19.5496 11.2664 20 13.3081 20 15.5C20 17.6201 19.5786 19.3187 19.1825 20.4472C18.8335 21.4415 17.8552 22 16.8014 22H7.19856C6.14477 22 5.16643 21.4415 4.81743 20.4471C4.42136 19.3187 4 17.62 4 15.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CableCarIcon;
